import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import MultiplePointsComponent from '../../../views/shared/multiplePoints';
import get from 'lodash/get';
import { getOpenapiInfo, getOpenapiUrl } from '../openapiHelpers';
import { ExpandFormRow } from '@here/ref-client-ui';

function MultiplePoints (props) {
  const {
    options: { openapiInfo },
    settings,
    fields: { customizations }
  } = props;
  const [openapiInfos, setOpenapiInfo] = useState(null);
  const isUnmounted = useRef(false);

  useEffect(() => {
    if (openapiInfo) {
      const { urlPath, urlRegex, urlSuffix, keys } = openapiInfo;
      const propsUrl = get(props, urlPath);
      const url = getOpenapiUrl(propsUrl, urlRegex, urlSuffix);
      getOpenapiInfo(url, keys, customizations, settings).then((openapiInfos) => {
        if (!isUnmounted.current) {
          setOpenapiInfo(openapiInfos);
        }
      });
    }

    return () => {
      isUnmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (points) => {
    const {
      options: { key },
      setFields,
    } = props;
    setFields({ [key]: JSON.stringify(points) });
  };

  const getTooltip = () => {
    const {
      options: { tooltip },
    } = props;
    let tooltipEl = null;
    if (tooltip || openapiInfos) {
      tooltipEl = (
        <div className="rf-form-view__tooltip">{tooltip || openapiInfos}</div>
      );
    }

    return tooltipEl;
  };

  const {
    options: { label, key, advancedOptions, isPost },
    fields,
  } = props;
  const points = JSON.parse(fields[key] || '[]');
  return (
    <ExpandFormRow
      label={label}
      isExpanded
      tooltip={getTooltip()}
      tooltipPlacement="right"
    >
      <MultiplePointsComponent
        options={advancedOptions}
        isPost={isPost}
        points={points}
        onChange={onChange}
      />
    </ExpandFormRow>
  );
}

MultiplePoints.propTypes = {
  fields: PropTypes.object,
  options: PropTypes.object,
  setFields: PropTypes.func.isRequired,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  parseUrl: ({ parsedParams, options, postData }) => {
    const { key } = options;
    const keyLowerCase = key.toLowerCase();
    if (postData) {
      return { [key]: JSON.stringify(postData[key]) };
    }
    const res = { [key]: parsedParams[keyLowerCase] || '' };
    delete parsedParams[keyLowerCase];
    return res;
  },
  defaultState: (options) => ({
    [options.key]: options.initValue || '',
  }),
  getRequestOptions: (fields, options) => {
    const { key, isPost } = options;

    if (!fields[key]) return {};

    if (isPost) {
      const points = JSON.parse(fields[key]);
      if (points.length === 0) return {};
      return {
        method: 'post',
        data: {
          [key]: points,
        },
      };
    } else {
      return {
        params: fields[key],
      };
    }
  },
  Component: MultiplePoints,
};
